export const GET_MESSAGES = 'GET_MESSAGES';
export const POST_MESSAGE = 'POST_MESSAGE';
export const GET_CHAT = 'GET_CHAT';
export const POST_CHAT = 'POST_CHAT';
